export default {
    _instagramContainer: null,
    _facebookContainer : null,
    init() {
        this._instagramContainer = document.querySelector('[data-instagram]');
        if (this._instagramContainer) {
            this._generateInstaFeed();
        }

        this._facebookContainer = document.querySelector('[data-facebook]');
        if (this._facebookContainer) {

        }
    },
    _generateInstaFeed() {
        const url = this._instagramContainer.getAttribute('data-instagram');
        if (!url) {
            return;
        }

        let instaUsername = new URL(url).pathname;
        if (instaUsername[0] === '/') {
            instaUsername = instaUsername.slice(1);
        }
        if (instaUsername.slice(-1) === '/') {
            instaUsername = instaUsername.slice(0, -1);
        }
    }
}